import { Component }          from '@angular/core';
import { NavController }      from 'ionic-angular';
import { MenuController }     from 'ionic-angular';
import { LoadingController }  from 'ionic-angular';
import { ToastController }    from 'ionic-angular';
import { TranslateService }   from '@ngx-translate/core';

import { Mixture }            from '../../shared/models/mixture';
import { MixturesResultPage } from '../mixtures-result/mixtures-result';
import { ApplicationService } from '../../shared/providers/application-service';
import { GoogleAnalytics } from '@ionic-native/google-analytics';
import { StorageHelper } from '../../shared/helpers/storage.helper';
import { SynchronizePage } from '../synchronize/synchronize';

@Component({
  selector:     'page-direct-search',
  templateUrl:  'direct-search.html',
  providers:    [ApplicationService]
})

export class DirectSearchPage
{
  mixtures        : Mixture[] = [];
  selectedMixture : Mixture   = null;
  searching       : boolean   = false;
  searchString    : string    = '';
  overlayIndex    : number    = 0;
  user            : any       = null;
  waitingLabel    : string    = "Please wait...";
  overlayArray    : string [] = ['assets/menu_overlay_4.png',
                                'assets/menu_overlay_5.png',
                                'assets/menu_overlay_6.png',
                                'assets/menu_overlay_7.png',
                                'assets/menu_overlay_8.png',
                                'assets/menu_overlay_9.png'];

  constructor(public navCtrl            : NavController,
              public loadingCtrl        : LoadingController,
              public toastCtrl          : ToastController,
              public translate          : TranslateService,
              public applicationService : ApplicationService,
              public menuCtrl           : MenuController,
              private analytics  : GoogleAnalytics)
  {
    var context = this;

    this.initTranslations();

    if(StorageHelper.getMixtures() === null)
  {
    this.presentToast('You need to synchronize your data before accessing this feature');
    this.navCtrl.push(SynchronizePage);
    return;
  }

    context.user = StorageHelper.getUser();
    context.initMixtures(function()
    {
      console.info("[Function] constructor -> mixtures are rested");
    });
  }

 ionViewDidLoad()
  {
    this.analytics.trackView("Direct search");
  }

  initTranslations()
  {
    var context = this;
    this.translate.get('PLEASE_WAIT').subscribe(
      value => {
        context.waitingLabel = value;
      })
  }

  toggleMenu()
  {
    this.menuCtrl.toggle();
  }

  selectMixture(item)
  {
    var context = this;

    this.initMixtures(function()
    {
      context.selectedMixture = item;
      var moleculeCompo       = '';
      var alEquiv             = '';

      var equivalent = context.mixtures.filter((mixt) =>
      {
        if(mixt.N2 != context.selectedMixture.N2)
          return false;

        if(mixt.O2 != context.selectedMixture.O2)
          return false;

        if(mixt.CO2 != context.selectedMixture.CO2)
          return false;

        if(mixt.He != context.selectedMixture.He)
          return false;

        if(mixt.Ar != context.selectedMixture.Ar)
          return false;

        if(mixt.H != context.selectedMixture.H)
          return false;

        if(mixt.NO != context.selectedMixture.NO)
          return false;

        if(mixt.Enterprise == "AIR LIQUIDE")
        {
          alEquiv = mixt.Name;
          return false;
        }

        if(mixt.Name == context.selectedMixture.Name)
          return false;

          return true;
        });

        moleculeCompo = context.getComposition();
        moleculeCompo = moleculeCompo.substr(0, moleculeCompo.length - 2);

        context.navCtrl.push(MixturesResultPage,
          {
            item,
            equivalent,
            moleculeCompo,
            alEquiv
          }, {animate: true});
        });
  }

  getComposition()
  {
    var moleculeCompo = '';
    var context       = this;

    if(context.selectedMixture.N2 != null)
      moleculeCompo = moleculeCompo + context.selectedMixture.N2 + '% N2, ';

    if(context.selectedMixture.O2 != null)
      moleculeCompo = moleculeCompo + context.selectedMixture.O2 + '% O2, ';

    if(context.selectedMixture.CO2 != null)
      moleculeCompo = moleculeCompo + context.selectedMixture.CO2 + '% CO2, ';

    if(context.selectedMixture.He != null)
      moleculeCompo = moleculeCompo + context.selectedMixture.He + '% He, ';

    if(context.selectedMixture.Ar != null)
      moleculeCompo = moleculeCompo + context.selectedMixture.Ar + '% Ar, ';

    if(context.selectedMixture.H != null)
      moleculeCompo = moleculeCompo + context.selectedMixture.H + '% H, ';

    if(context.selectedMixture.NO != null)
      moleculeCompo = moleculeCompo + context.selectedMixture.NO + '% NO ,';

    return moleculeCompo;
  }

  presentLoading()
  {
    var context = this;
    let loader = this.loadingCtrl.create({
       content:  context.waitingLabel
     });
     return loader;
  }

  presentToast(message)
  {
    let toast = this.toastCtrl.create({
      message: message,
      duration: 3000
    });
    toast.present();
  }

  initMixtures(callback)
  {
    let loader  = this.presentLoading();

    const mixtures = StorageHelper.getMixtures();
    if(mixtures != null)
      this.mixtures = mixtures;
    else
      this.presentToast("Missing mixtures, please synchronize before.");

    loader.dismiss();
    callback();
  }

  getmixtures(ev: any)
  {
    var context = this;
    let val = ev.target.value;
     // Reset items back to all of the items
     this.initMixtures(function()
     {
        if (val && val.trim() != '')
        {
           context.mixtures = context.mixtures.filter((item) =>
           {
             return (item.Name.toLowerCase().indexOf(val.toLowerCase()) > -1);
           })
        }
     });
   }

   getOverlay()
   {
     if(this.overlayIndex == 5)
       this.overlayIndex = 0;

     this.overlayIndex++;

     return this.overlayArray[this.overlayIndex];
   }

  searchProductLayout()
  {
    this.searching    = !this.searching;
    this.searchString = ''

    this.initMixtures(function()
    {
      console.info("[Function] searchProductLayout -> mixtures are rested");
    });
  }

  backAction()
  {
    this.navCtrl.pop({animate: false});
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/direct-search/direct-search.ts